<div>
  <div class="mx-4 float-end">
    <ng-autocomplete
      [data]="CourseList"
      [searchKeyword]="keyword"
      placeholder="Search Class"
      (selected)="selectEvent($event)"
      (inputChanged)="onChangeSearch($event)"
      (inputFocused)="onFocused($event)"
      [itemTemplate]="itemTemplate"
      [notFoundTemplate]="notFoundTemplate"
    >
    </ng-autocomplete>
    <i
      class="bx bx-search"
      style="
        position: absolute;
        top: 25px;
        right: 30px;
        color: #c9c9c9;
        font-weight: 600;
      "
    ></i>
  </div>
  <div class="clearfix"></div>
  <ng-template #itemTemplate let-item>
    <a [innerHTML]="item.COURSE_NAME"></a>
  </ng-template>

  <ng-template #notFoundTemplate let-notFound>
    <div [innerHTML]="notFound"></div>
  </ng-template>
</div>
